// src/utils/offlineMantencionBaseStore.js
// Persistencia local del dato base de una mantención (GET /mantenciones/:id),
// keyeado por id_mantencion. IndexedDB (localforage) porque el payload (ascensores
// + actividades) puede ser grande. Best-effort.
import localforage from 'localforage';

const store = localforage.createInstance({ name: 'prolift', storeName: 'offline-mant-base' });
const keyFor = (id) => String(id);

export async function saveMantencionBase(id, data) {
  if (id == null || data == null) return;
  try {
    await store.setItem(keyFor(id), { data, updatedAt: Date.now() });
  } catch {
    // best-effort
  }
}

export async function loadMantencionBase(id) {
  if (id == null) return null;
  try {
    const rec = await store.getItem(keyFor(id));
    return rec?.data ?? null;
  } catch {
    return null;
  }
}

export async function hasMantencionBase(id) {
  if (id == null) return false;
  try {
    return (await store.getItem(keyFor(id))) != null;
  } catch {
    return false;
  }
}

export async function clearMantencionBase(id) {
  if (id == null) return;
  try {
    await store.removeItem(keyFor(id));
  } catch {
    // best-effort
  }
}
